import { createContext, useContext, useMemo, useState } from 'react';

const HiddenMenuContext = createContext<{
  setMenuHidden: (hidden: boolean) => void;
  menuHidden: boolean;
}>({
  setMenuHidden: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  menuHidden: false,
});

export const HiddenMenuContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [menuHidden, setMenuHidden] = useState(false);

  return (
    <HiddenMenuContext.Provider
      value={useMemo(
        () => ({
          menuHidden,
          setMenuHidden,
        }),
        [menuHidden, setMenuHidden],
      )}
    >
      {children}
    </HiddenMenuContext.Provider>
  );
};

export const useHiddenMenu = () => useContext(HiddenMenuContext);
